import { render, staticRenderFns } from "./WordRow.vue?vue&type=template&id=2673f739&scoped=true"
import script from "./WordRow.vue?vue&type=script&lang=js"
export * from "./WordRow.vue?vue&type=script&lang=js"
import style0 from "./WordRow.vue?vue&type=style&index=0&id=2673f739&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2673f739",
  null
  
)

export default component.exports